import React from 'react';
import { Card, CardContent, Chip, Grid, Stack, Typography, Button } from '@mui/material';

import { RouterLink } from '@src/components/core/link';
import paths from '@src/paths';

function FlowHubPage() {
  return (
    <Stack spacing={3}>
      <div>
        <Typography variant="h4">Process Flows</Typography>
        <Typography color="text.secondary" variant="body2">
          Guided workflows for repetitive client operations.
        </Typography>
      </div>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card variant="outlined">
            <CardContent>
              <Stack spacing={1.5}>
                <div>
                  <Chip label="Live" color="success" size="small" />
                </div>
                <Typography variant="h6">ZIP Code Updates</Typography>
                <Typography color="text.secondary" variant="body2">
                  Intake ZIP requests, apply import changes, then push targeting to Facebook.
                </Typography>
                <div>
                  <Button component={RouterLink} href={paths.flows.zipCodeUpdates} variant="contained">
                    Open Flow
                  </Button>
                </div>
              </Stack>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card variant="outlined">
            <CardContent>
              <Stack spacing={1.5}>
                <div>
                  <Chip label="Planned" size="small" />
                </div>
                <Typography variant="h6">Budget Updates</Typography>
                <Typography color="text.secondary" variant="body2">
                  Upcoming guided flow for recurring budget changes.
                </Typography>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Stack>
  );
}

export default FlowHubPage;
